import { callAPI, callAPIWhiteToken } from '../config/api';

const PATH_API = process.env.REACT_APP_API;

export async function getMyProfile() {
	const url = `${PATH_API}/users/my-profile`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}

export async function getChildren(uniqueId: string) {
	const url = `${PATH_API}/users/children?code=${uniqueId}`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}

export async function getMyChildren() {
	const url = `${PATH_API}/users/my-children`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}

export async function getByReffCode(code: string) {
	const url = `${PATH_API}/users/reff/${code}`;
	return await callAPI({
		url,
		method: 'GET',
	});
}

export async function updateMyProfile(data: any) {
	const url = `${PATH_API}/users/update-my-profile`;
	return await callAPIWhiteToken({
		url,
		method: 'POST',
		data: data,
	});
}

export async function updateMemberType(data: any) {
	const url = `${PATH_API}/users/change-member-type`;
	return await callAPIWhiteToken({
		url,
		method: 'POST',
		data: data,
	});
}

export async function uploadMyPic(data: any) {
	const url = `${PATH_API}/users/upload-my-pic`;
	return await callAPIWhiteToken({
		url,
		method: 'POST',
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		data: data,
	});
}
